export const getters = {
  getAllPlans: (state) => {
    return state.plans;
  },
};
